module.exports = __webpack_public_path__ + "7916cc99c70db3a49c52eb5dc0c395da.png";